

export const TENANTS_COLLECTION_NAME = 'tenants';
